import React from "react";
import "./styles.css";
import { ReactComponent as AIIcon } from "../../../../../../../assets/icons/ai.svg";
import { ReactComponent as HomeIcon } from "../../../../../../../assets/icons/navigation/home.svg";
import { ReactComponent as ListIcon } from "../../../../../../../assets/icons/navigation/list.svg";
import { ReactComponent as PaymentIcon } from "../../../../../../../assets/icons/navigation/credit-card.svg";
import { ReactComponent as CustomerIcon } from "../../../../../../../assets/icons/customer.svg";
import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "../../../../../../../constants/common";
import { normalizeAlias } from "../../../../utils";
import { NewBadge } from "../../../../../NewBadge";

type NavBarProps = {
  onNavigate: () => void;
};

export const NavBar: React.FC<NavBarProps> = ({ onNavigate }) => {
  const location = normalizeAlias(useLocation()?.pathname);
  const activeRoute = Object.values(ROUTES)
    .slice()
    .sort((left, right) => normalizeAlias(right).length - normalizeAlias(left).length)
    .find(
      (route) =>
        location?.startsWith(normalizeAlias(route)) ||
        location === normalizeAlias(route),
    );
  const isMarketActive =
    location === normalizeAlias(ROUTES.classifieds) ||
    location.startsWith(`${normalizeAlias(ROUTES.classifieds)}/`);

  const strokeColor = "#818c99";
  const strokeActiveColor = "#c06198";

  const baseItemClasses =
    "flex items-center gap-3 rounded-2xl px-3 py-2 text-[14px] font-medium transition";

  // isAccent оставил в сигнатуре на всякий случай, но он больше не добавляет бордер
  const makeItemClasses = (isActive: boolean, _isAccent?: boolean) =>
    [
      baseItemClasses,
      isActive
        ? "bg-gradient-to-r from-[#f3bfdc] to-[#f9e2f0] text-[#7b305a]"
        : "text-slate-700 hover:bg-[#f7f4fa]",
    ].join(" ");

  return (
    <div className="flex flex-col gap-4 text-sm">
      {/* Разделы сервиса */}
      <div>
        <div className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-[#818c99]">
          Разделы сервиса
        </div>
        <div className="flex flex-col gap-1">
          <Link
            className={makeItemClasses(activeRoute === ROUTES.housings)}
            to={ROUTES.housings}
            onClick={onNavigate}
          >
            <HomeIcon
              width="22px"
              height="22px"
              stroke={
                activeRoute === ROUTES.housings
                  ? strokeActiveColor
                  : strokeColor
              }
            />
            Недвижимость от застройщика
          </Link>

          <Link
            className={makeItemClasses(isMarketActive)}
            to={ROUTES.classifieds}
            onClick={onNavigate}
          >
            <ListIcon
              width="22px"
              height="22px"
              stroke={
                isMarketActive ? strokeActiveColor : strokeColor
              }
            />
            Маркет
            <NewBadge text="Новинка" />
          </Link>

          <Link
            className={makeItemClasses(activeRoute === ROUTES.payment)}
            to="/payment"
            onClick={onNavigate}
          >
            <PaymentIcon
              width="22px"
              height="22px"
              stroke={
                activeRoute === ROUTES.payment ? strokeActiveColor : strokeColor
              }
            />
            Тарифы
          </Link>
        </div>
      </div>

      {/* Инструменты */}
      <div>
        <div className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-[#818c99]">
          Инструменты
        </div>
        <div className="flex flex-col gap-1">
          <Link
            className={makeItemClasses(activeRoute === ROUTES.aiSearch)}
            to="/ai-search"
            onClick={onNavigate}
          >
            <AIIcon
              width="22px"
              height="22px"
              stroke={
                activeRoute === ROUTES.aiSearch
                  ? strokeActiveColor
                  : strokeColor
              }
            />
            ИИ-поиск
          </Link>
          <Link
            className={makeItemClasses(activeRoute === ROUTES.clientBase)}
            to="/client-base"
            onClick={onNavigate}
          >
            <CustomerIcon
              width="22px"
              height="22px"
              stroke={
                activeRoute === ROUTES.clientBase
                  ? strokeActiveColor
                  : strokeColor
              }
            />
            База клиентов
            <NewBadge text="Новинка" />
          </Link>
        </div>
      </div>
    </div>
  );
};
